import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'heineken';

const supportEmail = {
	[customerGroup]: 'heineken@smoothr.de',
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyAhTAHZ8fiLACOVP3I9nYYmK29c0IzGfBk',
		authDomain: 'enrique-tomas-ea8fe.firebaseapp.com',
		projectId: 'enrique-tomas-ea8fe',
		storageBucket: 'enrique-tomas-ea8fe.firebasestorage.app',
		messagingSenderId: '99222302132',
		appId: '1:99222302132:web:9f8969855ca5021c1c96e1',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyAUJ0yCbuGUs9lDKehj-VGlD0oeU3XO__A',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	allergens_link: '',
	...apiEnvironment,
	hasRecommendations: true,
	hjid: 5035140,
	merchantId: '',
	merchantGoogleId: '',
};
